import React from 'react'
import { Grid } from "@mui/material"
import { AppAntSwitch, AppProvidersAutocomplete, AppSitesAutocomplete } from "@components"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { batch } from "@preact/signals-react"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function NotifyAvailability() {

	const { dataInfo: notify, setDataInfo: setNotify } = useAlertsDataInfo(
		(alertsDrawerData.peek()?.sameSites?.value ||
			alertsDrawerData.peek()?.sameProviders?.value ||
			alertsDrawerData.peek()?.sameProviders?.value ||
			!!alertsDrawerData.peek()?.sites?.length ||
			!!alertsDrawerData.peek()?.providers?.length ||
			alertsDrawerData.peek()?.excludeProviders?.value) || false
	)
	const {
		dataInfo: sameSites,
		setDataInfo: setSameSitesAvailable
	} = useAlertsDataInfo(alertsDrawerData.peek().sameSites || false)
	const {
		dataInfo: sameProviders,
		setDataInfo: setSameProvidersAvailable
	} = useAlertsDataInfo(alertsDrawerData.peek().sameProviders || false)
	const { dataInfo: sites, setDataInfo: setSitesAvailable } = useAlertsDataInfo(alertsDrawerData.peek().sites || [])
	const {
		dataInfo: providers,
		setDataInfo: setProvidersAvailable
	} = useAlertsDataInfo(alertsDrawerData.peek().providers || [])
	const {
		dataInfo: excludeProviders,
		setDataInfo: setExcludeProvidersAvailable
	} = useAlertsDataInfo(alertsDrawerData.peek().excludeProviders || false)


	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<AppAntSwitch
				trueText="Notify when available"
				checked={notify.value}
				onChange={e => setNotify(e.target.checked, 'notify')}
			/>
		</Grid>
		{notify.value && <>
			<Grid item xs={12}>
				<AppAntSwitch
					trueText="Same sites"
					checked={sameSites.value}
					disabled={sameProviders.value}
					onChange={e => batch(() => {
						setSitesAvailable([], 'sites')
						setSameSitesAvailable(e.target.checked, 'sameSites')
					})}
				/>
			</Grid>
			<Grid item xs={9}>
				<AppSitesAutocomplete
					value={sites.value}
					onChange={e => setSitesAvailable(e.target.value, 'sites')}
					disabled={sameSites.value}
				/>
			</Grid>
			<Grid item xs={12}>
				<AppAntSwitch
					trueText="Same providers"
					checked={sameProviders.value}
					disabled={sameSites.value}
					onChange={e => batch(() => {
						setProvidersAvailable([], 'providers')
						setSameProvidersAvailable(e.target.checked, 'sameProviders')
					})}
				/>
			</Grid>
			<Grid item xs={9}>
				<AppProvidersAutocomplete
					value={providers.value}
					onChange={e => setProvidersAvailable(e.target.value, 'providers')}
					disabled={sameProviders.value}
				/>
			</Grid>
			<Grid item xs={3}>
				<AppAntSwitch
					trueText="Exclude providers"
					checked={excludeProviders.value}
					onChange={e => setExcludeProvidersAvailable(e.target.checked, 'excludeProviders')}
				/>
			</Grid>
		</>}
	</Grid>
}